if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      document.querySelectorAll('.suggested-products input[type=checkbox]').forEach((checkbox) => {
        window.onload = function() {
          const containerDiv = checkbox.parentNode;
          checkbox.checked ? containerDiv.classList.add('is-checked'): '';
        }
        checkbox.addEventListener('change', this.onChangeHandler.bind(this));
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // const config = fetchConfig('javascript');
      // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // delete config.headers['Content-Type'];

      let data = {
        items: [{
          id: this.querySelector('[name=id]').value,
          quantity: this.querySelector('[name=quantity]').value,
        }]
      }
      const suggested_products = document.querySelectorAll('.suggested-products input');

      suggested_products.forEach(function(item) {
        if (item.checked) {
          item.quantity = item.parentNode.querySelector('[name=quantity]').value;
          data.items.push({id: item.value, quantity: item.quantity});
        }
      });

      data.sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
      data.sections_url = window.location.pathname;

      fetch('/cart/add.js', {
        body: JSON.stringify(data),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
          //alert('dd');
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        if ($("body").hasClass("btn_outside")) {
        var mnhg = $(".main-head").height();
        $('html, body').animate({
        scrollTop: $(".product-form__error-message-wrapper").offset().top - mnhg
        }, 700);
        } 
      }
    }

    onChangeHandler(evt) {
      const checkbox = evt.target;
      const containerDiv = checkbox.parentNode;
      if(checkbox.checked) {
        containerDiv.classList.add('is-checked');
      } else {
        containerDiv.classList.remove('is-checked');
      }
    }
  });
}
